import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllHostsCountWs, selectIsReadOnly, selectTotalHostsCount } from 'store/Faraday/selectors';
import { RiFileEditLine as EditLine, RiFileDownloadLine as DownloadLine } from 'react-icons/ri';
import ManualCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ManualCreationModal';
import ImportFileCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ImportFileCreationModal';
import useClickOutside from 'Hooks/useClickOutside';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_BULK_CREATE, FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { fetchGlobalHostsIsAllowed } from 'store/Host/selectors';
import { getTotalHosts } from 'store/Host/actions';
import AddButton from 'shared/ui/AddButton';
import {
  DropdownItem, Wrapper, Dropdown
} from './styled';
import { openModal } from 'store/modals/actions';
import { MODAL_CANT_CREATE } from 'store/modals/modals';
import { getWorkspaces } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { selectEmptyActiveWorkspaces } from 'store/Workspace/selectors';
import { useIntl } from 'react-intl';

const CreateActions = ({ entity }) => {
  const intl = useIntl();
  const [showModalCreation, setShowModalCreation] = useState(false);
  const [showModalImport, setShowModalImport] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const manualCreationAllowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.CREATE));
  const importVulnsAllowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_BULK_CREATE, PERMISSION_TYPES.CREATE));
  const canGetGlobalHostsCount = useSelector(fetchGlobalHostsIsAllowed);
  const dispatch = useDispatch();
  const readOnly = useSelector(selectIsReadOnly);
  const disabledButton = entity === 'vulnsGeneral'
    ? (!manualCreationAllowedByRole && !importVulnsAllowedByRole)
    : readOnly || (!manualCreationAllowedByRole && !importVulnsAllowedByRole);
  const canShowManualCreation = entity === 'vulnsGeneral' ? manualCreationAllowedByRole : !readOnly && manualCreationAllowedByRole;
  const canShowImportVulns = entity === 'vulnsGeneral' ? importVulnsAllowedByRole : !readOnly && importVulnsAllowedByRole;
  const assetsCount = useSelector(selectAllHostsCountWs);
  const noAssets = assetsCount === 0;
  const assetsCountAllWorkspaces = useSelector(selectTotalHostsCount);
  const noAssetsFromAllWorkspaces = assetsCountAllWorkspaces === 0;
  const noWorkspaces = useSelector(selectEmptyActiveWorkspaces);

  const dropdownRef = useRef();
  useClickOutside(dropdownRef, () => setShowDropdown(false));

  const handleShow = () => {
    if ((noAssets && (entity === 'vulns')) || ((entity === 'vulnsGeneral') && (noAssetsFromAllWorkspaces || noWorkspaces))) dispatch(openModal(MODAL_CANT_CREATE));
    else setShowModalCreation(true);
    setShowDropdown(false);
  };
  const handleClose = () => setShowModalCreation(false);
  const handleShowImportFromFile = () => {
    setShowModalImport(true);
    setShowDropdown(false);
    dispatch(getWorkspaces(false, false));
  };
  const handleCloseImportFromFile = () => setShowModalImport(false);

  const handleDropdown = () => {
    if (!disabledButton) setShowDropdown(!showDropdown);
    if (canGetGlobalHostsCount && !showDropdown) dispatch(getTotalHosts()); // calcula el total de hosts sin filtro.
  };

  return (
    <Wrapper ref={ dropdownRef }>
      <AddButton onClick={ handleDropdown } data-tour="Add Vulnerability" disabled={ disabledButton }>
        {intl.formatMessage({ id: 'common.button.add.vulnerability' }) }
      </AddButton>
      {showDropdown && (
      <Dropdown>
        { canShowManualCreation &&
          <DropdownItem onClick={ handleShow } role="button" aria-label="Manual Creation" type="button">
            <EditLine size="1.3em" color="#5a6b7d" />
            Manual Creation
          </DropdownItem>
        }
        { canShowImportVulns &&
          <DropdownItem onClick={ handleShowImportFromFile } role="button" aria-label="Import from File" type="button">
            <DownloadLine size="1.3em" color="#5a6b7d" />
            Import from File
          </DropdownItem>
        }
      </Dropdown>
      )}

      { showModalImport && <ImportFileCreationModal handleClose={ handleCloseImportFromFile } entity={ entity } /> }
      { showModalCreation && <ManualCreationModal handleClose={ handleClose } entity={ entity } /> }
    </Wrapper>
  );
};

export default CreateActions;
